import { mapLog } from '../logger';
/**
 * Callback index.
 */
var count = 0;
/**
 * Noop function.
 */
function noop() {
    // nothing
}
function jsonp(url, opts, fn) {
    var _a;
    if ('function' == typeof opts) {
        fn = opts;
        opts = {};
    }
    if (!opts)
        opts = {};
    var prefix = opts.prefix || '__jp';
    // use the callback name that was passed if one was provided.
    // otherwise generate a unique name by incrementing our counter.
    var id = opts.name || prefix + count++;
    var param = opts.param || 'callback';
    var timeout = null != opts.timeout ? opts.timeout : 60000;
    var enc = encodeURIComponent;
    var target = document.getElementsByTagName('script')[0] || document.head;
    // eslint-disable-next-line
    var script;
    var timer;
    if (timeout) {
        timer = setTimeout(function () {
            cleanup();
            if (fn)
                fn(new Error('Timeout'));
        }, timeout);
    }
    function cleanup() {
        if (script.parentNode)
            script.parentNode.removeChild(script);
        // @ts-ignore
        window[id] = noop;
        if (timer)
            clearTimeout(timer);
    }
    function cancel() {
        // @ts-ignore
        if (window[id]) {
            cleanup();
        }
    }
    // @ts-ignore
    window[id] = function (data) {
        mapLog('jsonp got', [data]);
        cleanup();
        if (fn)
            fn(null, data);
    };
    // add qs component
    url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
    url = url.replace('?&', '?');
    mapLog('jsonp req "%s"', [url]);
    // create script
    script = document.createElement('script');
    script.src = url;
    script.onerror = function () {
        cleanup();
        if (fn)
            fn(new Error('Error Script Jsonp'));
    };
    (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, target);
    return cancel;
}
/**
 * Module exports.
 */
export default jsonp;
//# sourceMappingURL=data:application/json;base64,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